import React, {useMemo, useRef} from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { formatDate } from '../../sc-utilities';
import ActiveCustomerList from './ActiveCustomerList';
import { CustomChip } from '../../sc-components';
import * as actions from './store/activeCustomerActions';
import { ExitToApp } from "@material-ui/icons";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            marginLeft: 10,
            color: theme.palette.success.dark
        },

        "[class*='restrictions']": {
            color: theme.palette.error.dark,
            fontSize: 12

        },
        "[class*='no_restrictions']": {
            color: theme.palette.success.dark,
            fontSize: 12

        }
    },
    no_restrictions: {
        color: theme.palette.success.dark,
        fontSize: 12

    },
    restrictions: {
        color: theme.palette.error.dark,
        fontSize: 12

    }
});

const ActiveCustomer = props => {
    const tableRef = useRef();
    const { classes, columns, translations, activeCustomerID, onChangeActiveCustomer } = props;
    let visible = columns && columns['ActiveCustomer'];

    const tableColumns = useMemo(() => {
        return [
            {
                title: translations["action"] || "Action", field: 'Action',
                hidden: visible ? visible['Action'] : false,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                filtering: false,
                render: rowData => <>
                    {activeCustomerID === rowData.CustomerID ? <CustomChip key={`active_${rowData.CustomerID}`} className={'statusActive'} value={translations['active'] || 'Active'} /> : (
                        <Tooltip title={translations["change_active_customer"] || "Change active customer"}>
                            <IconButton
                                disabled={rowData.Selectable === false}
                                value={rowData.CustomerID}
                                aria-label={translations["change_active_customer"] || "Change active customer"}
                                onClick={() => onChangeActiveCustomer(rowData.CustomerID)}
                            >
                                <ExitToApp />
                            </IconButton>
                        </Tooltip>
                    )}
                </>
            },
            {
                title: translations["name"] || 'Name', field: 'Name',
                hidden: visible ? visible['Name'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["namespace"] || 'Namespace', field: 'Namespace',
                hidden: visible ? visible['Namespace'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Namespace ? rowData.Namespace : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["created_at"] || "Created at",
                field: "CreatedAt",
                hidden: visible ? visible["CreatedAt"] : false,
                filtering: true,
                type: 'date',
                render: (rowData) => {
                    return <Typography variant={"caption"}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
                },
            },
            {
                title: translations["notes"] || "Notes",
                field: "Notes",
                hidden: visible ? visible["Notes"] : false,
                filtering: false,
                render: (rowData) => {
                    return <CustomChip key={`notes_${rowData.CustomerID}`} trimming={true} className={rowData.Selectable === false ? 'restrictions' : 'no_restrictions'} value={rowData.Reason ? rowData.Reason : translations['no_restrictions'] || "No restrictions"} />;
                },
            },
        ];
    }, [translations, visible, activeCustomerID, onChangeActiveCustomer])


    return (
        <div className={classes.root}>
            <ActiveCustomerList
                tableColumns={tableColumns}
                tableRef={tableRef}
            />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer?.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeActiveCustomer: filter => dispatch(actions.changeActiveCustomer(filter)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ActiveCustomer));
